module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-column"
  }, [_c('main', {
    staticClass: "flex-grow-1"
  }, [_c('h1', {
    staticClass: "f2 lh-copy pt3"
  }, [_vm._v("Support")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "grid-half mv4"
  }, [_c('router-link', {
    staticClass: "no-underline",
    attrs: {
      "to": "/faq"
    }
  }, [_c('ak-tile', {
    attrs: {
      "header": "FAQ",
      "subheader": "Info on pricing, plans, claims, and more",
      "classlist": "hover-lift"
    }
  })], 1), _vm._v(" "), _c('router-link', {
    staticClass: "no-underline",
    attrs: {
      "to": "/contact"
    }
  }, [_c('ak-tile', {
    attrs: {
      "header": "Support",
      "subheader": "Contact us",
      "classlist": "hover-lift"
    }
  })], 1)], 1)]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt4"
  }, [_c('div', {
    staticClass: "mb4 f3"
  }, [_vm._v("\n        We’ve got you covered. How can we help?\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tc mt7-ns",
    attrs: {
      "id": "footer"
    }
  }, [_c('a', {
    staticClass: "gray",
    attrs: {
      "href": "mailto:billing@getakko.com"
    }
  }, [_vm._v("Click here to request to cancel your plan")]), _vm._v(" or email billing@getakko.com\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6999f707","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SupportPage.vue
// module id = 1523
// module chunks = 0